import { SUPPORTED_LOCALES, JOBALTO_URL, IS_SNAP } from 'variables/main';
import { SNAP_LOCALIZED } from 'variables/main';
import config from 'config';
import getCountry from 'helpers/getCountry';
import { localeToFlagAlpha2 } from 'helpers/flags';

// "Localized domain" used to mean strictly hostname === jobalto.com — fine for
// production, but on localhost it forced the bundle into profitroll mode even
// when built with config.jobalto.json. Honour config.brand (baked in at build
// time by Dockerfile's `cp src/config.${BRAND}.json src/config.json`) so the
// dev server picks the right brand assets, locale fallback, and breadcrumb
// site name.
const isLocalizedDomain = () => {
  if (IS_SNAP && SNAP_LOCALIZED) return true;
  if (config.brand === 'jobalto') return true;
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return false;
  return hostname === JOBALTO_URL || hostname === `www.${JOBALTO_URL}`;
};

const getLocalizedPath = (path) => {
  if (isLocalizedDomain()) {
    const locale = getLocale();
    const country = getCountry() || localeToFlagAlpha2(locale);
    const withSlash = path.startsWith('/') ? path : '/' + path;
    return `/${locale}-${country}${withSlash}`;
  }
  return path;
};

const getLocale = () => {
  if (typeof window === 'undefined') {
    return 'en'; // Default for SSR/pre-rendering
  }

  const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
  let locale = firstSegment;

  if (firstSegment.includes('-')) {
    const [loc] = firstSegment.split('-');
    locale = loc || '';
  }

  if (SUPPORTED_LOCALES.includes(locale)) {
    return locale;
  }

  // For jobalto.com, default to English
  if (isLocalizedDomain()) {
    return 'en';
  }

  // For profitroll.com.ua, default to Ukrainian
  return SUPPORTED_LOCALES[0];
};

export default getLocale;

export { isLocalizedDomain, getLocalizedPath };
